import { createSelector } from 'reselect'
import get from 'lodash/get'
import { groupArchiveListByDay } from 'features/list/utils'

const getArchiveTeamList = state => state.teamlist.items.archive.list
const getItems = state => state.teamlist.items
const getItemsLoaded = state => state.teamlist.itemsLoaded
const getTeamMembers = state => state.teamlist.teamMembers
const getTeamMembersLoaded = state => state.teamlist.teamMembersLoaded

export const getArchiveListGroupedByDay = createSelector(
  [getArchiveTeamList],
  archiveList => {
    return groupArchiveListByDay(archiveList)
  }
)

export const getLastSortKey = createSelector(
  [getArchiveTeamList],
  list => {
    if (!list || list.length === 0) {
      return ''
    }
    const lastSortKey = list[list.length - 1].assigneeCompletionTime
    return lastSortKey
  }
)

export const hasNoMember = createSelector(
  [getTeamMembersLoaded, getTeamMembers],
  (teamMembersLoaded, teamMembers) => {
    return teamMembersLoaded && teamMembers.length === 0
  }
)

export const hasNoTask = createSelector(
  [getItemsLoaded, getItems],
  (itemsLoaded, items) => {
    if (!itemsLoaded) {
      return false
    }
    for (const group in items) {
      if (group !== 'archive' && get(items, `${group}.list.length`) > 0) {
        return false
      }
    }
    return true
  }
)



// WEBPACK FOOTER //
// ./src/features/teamlist/store/selectors.js